import { Controller } from "@hotwired/stimulus"

// Columna lateral fija en escritorio (sticky): filtros de /recursos, columna
// de la ficha, buscador del planificador. Si cabe en la pantalla queda fija
// bajo el header, como siempre. Si es más alta (notebooks), el tope se
// vuelve negativo: acompaña el scroll hasta mostrar su final y recién ahí
// se fija, así se alcanza a ver completa.
const ESCRITORIO = "(min-width: 1024px)" // donde el panel es sticky (lg:)
const TOPE = 96 // lg:top-24, bajo el header
const MARGEN_INFERIOR = 16

export default class extends Controller {
  connect() {
    this.escritorio = window.matchMedia(ESCRITORIO)
    this.ajustar = () => this.calcular()
    this.observador = new ResizeObserver(this.ajustar) // cambia el alto (temas desplegados, frames que cargan)
    this.observador.observe(this.element)
    window.addEventListener("resize", this.ajustar)
    this.escritorio.addEventListener("change", this.ajustar)
    this.calcular()
  }

  disconnect() {
    this.observador.disconnect()
    window.removeEventListener("resize", this.ajustar)
    this.escritorio.removeEventListener("change", this.ajustar)
  }

  calcular() {
    if (!this.escritorio.matches) {
      this.element.style.removeProperty("top")
      return
    }
    const tope = Math.min(TOPE, window.innerHeight - this.element.offsetHeight - MARGEN_INFERIOR)
    this.element.style.top = `${tope}px`
  }
}
